module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-village_hb.png?v=e586d50e";